import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import get from '../utils/get';
import uniqBy from '../utils/uniqBy';
import { transFormError } from '../utils/tools';
import { GET_LIST, CRUD_FAILURE, SET_ITEM, SET_ITEMS, CONCAT_ITEMS, FILTER_ITEMS, GET_ONE, GET_ONE_SUCCESS, GET_LIST_SUCCESS, CREATE_SUCCESS, CREATE_MANY_SUCCESS, UPDATE_SUCCESS, UPDATE_MANY_SUCCESS, DELETE_SUCCESS, DELETE_MANY_POST_SUCCESS, RESET_CRUD_ERROR, CREATE, UPDATE, PATCH_SUCCESS, UPLOAD_SUCCESS, UPLOAD_MANY_SUCCESS, GET_ONE_LOADING, GET_LIST_LOADING, SUGGEST_SEARCH_LOADING, RESET, UPDATE_MANY_POST_SUCCESS } from '../actions/constants';

var defaultGetId = function defaultGetId(e) {
  return e === null || e === void 0 ? void 0 : e.id;
};

var removeItems = function removeItems(items, id) {
  var predicate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (e) {
    return e.id === id;
  };
  return items.filter(function (e) {
    return !predicate(e);
  });
};

var reducerConfigGenerator = function reducerConfigGenerator(_ref) {
  var name = _ref.name,
      surchargeReducer = _ref.surchargeReducer,
      initialState = _ref.initialState;
  var reducer = {};
  [GET_ONE_LOADING, GET_LIST_LOADING, "".concat(GET_LIST_LOADING, "/").concat(name), SUGGEST_SEARCH_LOADING].forEach(function (type) {
    // TODO: to be removed in preference of loadingsActions
    reducer[type] = function (state, action) {
      var chunkResource = action.chunkResource;
      return _objectSpread(_objectSpread({}, state), {}, _defineProperty(_defineProperty(_defineProperty({}, "isLoading".concat(chunkResource || ''), true), "isLoading", true), "error", null));
    };
  });
  [GET_ONE, "".concat(GET_ONE, "/").concat(name)].forEach(function (type) {
    reducer[type] = function (state, action) {
      var queryOne = _objectSpread(_objectSpread({}, action.payload), {}, {
        timestamp: Date.now()
      });

      return _objectSpread(_objectSpread({}, state), {}, {
        queryOne: queryOne
      });
    };
  });
  [GET_ONE_LOADING, "".concat(GET_ONE_LOADING, "/").concat(name)].forEach(function (type) {
    // TODO: to be removed in preference of loadingsActions
    reducer[type] = function (state) {
      return _objectSpread(_objectSpread({}, state), {}, {
        isGetOneLoading: true,
        error: null
      });
    };
  });

  reducer[CRUD_FAILURE] = function (state, action) {
    var payload = action.payload,
        resource = action.resource,
        chunkResource = action.chunkResource;

    var failedActions = _toConsumableArray(state.failedActions);

    failedActions.push(payload);

    var items = _toConsumableArray(state.items);

    var index = -1;

    if (get(payload, 'action.type') === CREATE) {
      index = items.findIndex(function (e) {
        return e.id === "".concat(resource).concat(payload.action.timeStampRequest);
      });
    } else if (get(payload, 'action.type') === UPDATE) {
      index = items.findIndex(function (e) {
        return e.id === payload.action.payload.id;
      });
    }

    if (index !== -1) {
      items[index].error = payload.action;
    }

    var error = transFormError(action.error, payload.action);
    return _objectSpread(_objectSpread({}, state), {}, _defineProperty(_defineProperty(_defineProperty({
      items: items,
      isLoading: false
    }, "isLoading".concat(chunkResource || ''), false), "error", error), "failedActions", failedActions));
  };

  reducer[RESET_CRUD_ERROR] = function (state) {
    return _objectSpread(_objectSpread({}, state), {}, {
      error: null
    });
  };

  reducer[SET_ITEM] = function (state, action) {
    var item = action.payload.item;
    return _objectSpread(_objectSpread({}, state), {}, {
      item: item
    });
  };

  reducer[SET_ITEMS] = function (state, action) {
    var items = action.payload.items;
    return _objectSpread(_objectSpread({}, state), {}, {
      items: items
    });
  };

  reducer[CONCAT_ITEMS] = function (state, action) {
    var items = action.payload.items;
    return _objectSpread(_objectSpread({}, state), {}, {
      items: [].concat(_toConsumableArray(state.items), _toConsumableArray(items))
    });
  };

  reducer[FILTER_ITEMS] = function (state, action) {
    var _action$payload = action.payload,
        keyValue = _action$payload.keyValue,
        keyTarget = _action$payload.keyTarget;
    var items = state.items.filter(function (item) {
      return item[keyTarget] !== keyValue;
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      items: items
    });
  };

  [GET_ONE_SUCCESS, "".concat(GET_ONE_SUCCESS, "/").concat(name)].forEach(function (type) {
    reducer[type] = function (state, action) {
      var _action$getId = action.getId,
          getId = _action$getId === void 0 ? defaultGetId : _action$getId,
          target = action.target;
      var merged = {};

      if (target !== 'list') {
        merged = {
          item: get(action, 'payload.items', action.payload)
        };
      } else {
        var items = state.items.map(function (item) {
          if (getId(item) !== getId(action.payload)) {
            return item;
          }

          return _objectSpread({}, action.payload);
        });

        if (!items.find(function (item) {
          return getId(item) === getId(action.payload);
        })) {
          items.push(_objectSpread({}, action.payload));
        }

        if (state.item && getId(state.item) === getId(action.payload)) {
          merged = {
            items: items,
            item: action.payload
          };
        } else {
          merged = {
            items: items
          };
        }
      }

      return _objectSpread(_objectSpread(_objectSpread({}, state), merged), {}, {
        isGetOneLoading: false,
        error: null
      });
    };
  });
  [GET_LIST, "".concat(GET_LIST, "/").concat(name)].forEach(function (type) {
    reducer[type] = function (state, action) {
      var isReplace = action.isReplace;

      var query = _objectSpread(_objectSpread({}, action.payload), {}, {
        timestamp: Date.now()
      });

      var queries = isReplace ? [query] : [].concat(_toConsumableArray(state.queries), [query]);
      return _objectSpread(_objectSpread({}, state), {}, {
        queries: queries
      });
    };
  });
  [GET_LIST_SUCCESS, "".concat(GET_LIST_SUCCESS, "/").concat(name)].forEach(function (type) {
    reducer[type] = function (state, action) {
      var isReplace = action.isReplace,
          payload = action.payload,
          isUnique = action.isUnique;
      var newItems = payload.items,
          total = payload.total;
      var oldItems = isUnique ? state.items.filter(function (item) {
        return !newItems.find(function (newItem) {
          return newItem.id === item.id;
        });
      }) : state.items;
      var items = isReplace ? newItems : [].concat(_toConsumableArray(oldItems), _toConsumableArray(newItems));
      return _objectSpread(_objectSpread({}, state), {}, {
        items: items,
        total: total,
        isLoading: false,
        error: null
      });
    };
  });

  reducer[CREATE_SUCCESS] = function (state, action) {
    var timeStampRequest = action.timeStampRequest,
        resource = action.resource,
        isListDst = action.isListDst,
        payload = action.payload;
    var id = "".concat(resource).concat(timeStampRequest);

    var items = _toConsumableArray(state.items);

    var failedActions = removeItems(_toConsumableArray(state.failedActions), id, function (e) {
      return e.action.timeStampRequest === timeStampRequest;
    });
    var item = state.item;
    var indexItems = items.findIndex(function (e) {
      return e.id === id;
    });

    if (item && item.id === id) {
      item = _objectSpread(_objectSpread(_objectSpread({}, item), payload), {}, {
        error: null
      });
    } else if (!isListDst) {
      item = _objectSpread(_objectSpread({}, payload), {}, {
        error: null
      });
    }

    if (indexItems !== -1) {
      items[indexItems] = _objectSpread(_objectSpread({}, payload), {}, {
        id: payload.id,
        error: null
      });
    } else if (isListDst) {
      items.push(_objectSpread(_objectSpread({}, payload), {}, {
        error: null
      }));
    }

    return _objectSpread(_objectSpread({}, state), {}, {
      item: item,
      items: uniqBy(items, 'id'),
      failedActions: failedActions,
      isLoading: false,
      error: null
    });
  };

  reducer[CREATE_MANY_SUCCESS] = function (state, action) {
    var items = _toConsumableArray(state.items);

    for (var i = 0; i < action.payload.length; i++) {
      items.push(_objectSpread({}, action.payload[i]));
    }

    return _objectSpread(_objectSpread({}, state), {}, {
      items: items,
      isLoading: false,
      error: null
    });
  };

  reducer[PATCH_SUCCESS] = function (state, action) {
    var _action$payload2;

    var id = (_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.id;

    if (!id) {
      // Don't update the store when the client receives a response without content to a PATCH request.
      return state;
    }

    var item = state.item ? _objectSpread({}, state.item) : null;

    var items = _toConsumableArray(state.items);

    var index = items.findIndex(function (e) {
      return e.id === id;
    });

    if (index !== -1) {
      // items[index] = { ...items[index], ...action.payload, error: null };
      // WARNING: THE API RETURN REPLACE STATE
      items[index] = _objectSpread(_objectSpread({}, action.payload), {}, {
        error: null
      });
    }

    var failedActions = removeItems(_toConsumableArray(state.failedActions), id, function (e) {
      return e.action.payload.id === id;
    });

    if (item && item.id === id) {
      // item = { ...state.item, ...action.payload, error: null };
      // WARNING: THE API RETURN REPLACE STATE
      item = _objectSpread(_objectSpread({}, action.payload), {}, {
        error: null
      });
    }

    return _objectSpread(_objectSpread({}, state), {}, {
      item: item,
      items: items,
      failedActions: failedActions,
      isLoading: false,
      error: null
    });
  };

  reducer[UPDATE_SUCCESS] = function (state, action) {
    var _action$getId2 = action.getId,
        getId = _action$getId2 === void 0 ? defaultGetId : _action$getId2,
        payload = action.payload;
    var id = getId(payload);
    var item = state.item ? _objectSpread({}, state.item) : null;

    var items = _toConsumableArray(state.items);

    var index = items.findIndex(function (e) {
      return getId(e) === id;
    });

    if (index !== -1) {
      items[index] = _objectSpread(_objectSpread({}, payload), {}, {
        error: null
      });
    }

    var failedActions = removeItems(_toConsumableArray(state.failedActions), id, function (e) {
      return getId(e.action.payload) === id;
    });

    if (item && getId(item) === id) {
      item = _objectSpread(_objectSpread({}, payload), {}, {
        error: null
      });
    }

    return _objectSpread(_objectSpread({}, state), {}, {
      item: item,
      items: items,
      failedActions: failedActions,
      isLoading: false,
      error: null
    });
  };

  reducer[UPDATE_MANY_POST_SUCCESS] = function (state, action) {
    var items = state.items.map(function (item) {
      var index = action.payload.items.findIndex(function (e) {
        return !!e.id && !!item.id && e.id === item.id;
      });

      if (index !== -1) {
        return action.payload.items[index];
      }

      return item;
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      items: items,
      isLoading: false,
      error: null
    });
  };

  reducer[UPDATE_MANY_SUCCESS] = function (state, action) {
    var items = state.items.map(function (item) {
      var index = action.payload.findIndex(function (e) {
        return e.id === item.id;
      });

      if (index !== -1) {
        return action.payload[index];
      }

      return item;
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      items: items,
      isLoading: false,
      error: null
    });
  };

  [DELETE_MANY_POST_SUCCESS, "".concat(DELETE_MANY_POST_SUCCESS, "/").concat(name)].forEach(function (type) {
    reducer[type] = function (state, action) {
      var _ref2 = (action === null || action === void 0 ? void 0 : action.query) || {},
          ids = _ref2.ids;

      var items = state.items;
      var newItems = items.filter(function (_ref3) {
        var id = _ref3.id;
        return !ids.includes(id);
      });
      return _objectSpread(_objectSpread({}, state), {}, {
        items: newItems
      });
    };
  });

  reducer[DELETE_SUCCESS] = function (state, action) {
    var _state$item;

    var id = action.payload.id;
    var items = removeItems(_toConsumableArray(state.items), id);
    var item = !state.item || ((_state$item = state.item) === null || _state$item === void 0 ? void 0 : _state$item.id) === id ? null : state.item;
    return _objectSpread(_objectSpread({}, state), {}, {
      items: items,
      item: item,
      isLoading: false,
      error: null
    });
  };

  reducer[UPLOAD_SUCCESS] = function (state, action) {
    var newState;

    if (action.isListDst) {
      var items = _toConsumableArray(state.items);

      items.push(action.payload);
      newState = {
        items: items
      };
    } else {
      newState = {
        item: action.payload
      };
    }

    return _objectSpread(_objectSpread(_objectSpread({}, state), newState), {}, {
      isLoading: false,
      error: null
    });
  };

  reducer[UPLOAD_MANY_SUCCESS] = function (state, action) {
    var newState;

    if (action.isListDst) {
      var items = _toConsumableArray(state.items);

      items.push(action.payload);
      newState = {
        items: items
      };
    } else {
      newState = {
        item: action.payload
      };
    }

    return _objectSpread(_objectSpread(_objectSpread({}, state), newState), {}, {
      isLoading: false,
      error: null
    });
  };

  reducer.WS_DELETE = reducer[DELETE_SUCCESS];

  reducer[RESET] = function () {
    return _objectSpread({}, initialState);
  };

  reducer.default = function (state) {
    return state;
  };

  return _objectSpread(_objectSpread({}, reducer), surchargeReducer(reducer));
};

export default reducerConfigGenerator;
//# sourceMappingURL=reducerConfigGenerator.js.map